
<!-- 背景调查页面 -->
<template>
  <div class="app">
    <header-Top :topBgimg="require('../assets/backdropInquiry_top_bg1.png')" descType="backdropInquiry"></header-Top>
    <div class="panel1 flex_rowC">
      <div class="panel1-item flex_row_between textC">
        <div class="">
          <div class="title">5万+</div>
          <div class="desc">服务企业客户案例</div>
        </div>
        <div class="">
          <div class="title">20W+</div>
          <div class="desc">专业HR联盟社群</div>
        </div>
        <div class="">
          <div class="title">100W+</div>
          <div class="desc">累计出具背调报告</div>
        </div>
        <div class="">
          <div class="title">1亿+</div>
          <div class="desc">每年背调行为数据</div>
        </div>
      </div>
    </div>

    <div class="panel2 textC flex_col_between">
      <div class="title">
        招错人，企业有多痛？
      </div>
      <div class="desc">
        身份造假的员工是在逃犯 <br>
        严重经济风险的财务卷款跑路 <br>
        有不良记录的保姆纵火 <br>
        习惯性“劳动仲裁”选手 <br>
        深陷网贷的程序员删库跑路 <br>
        有商业利益冲突的高管 <br>
        …
      </div>
    </div>

    <div class="panel3">
      <div class="title textC">
        领先的背景调查服务，全方位保障企业用工安全！
      </div>
      <div class="flex_rowC">
        <div class="video">
          <video src="https://share.luobobeidiao.cn/promotion_video.mp4" controls></video>
        </div>
      </div>
    </div>

    <div class="panel4 textC">
      <div class="title">我们的背景调查项目</div>
      <div class="desc">29项客观信息 37个维度 多组合查询验证</div>
      <div class="flex_rowC">
        <div class="items flex_rows_start">
          <div class="item flex_rowC" v-for="(item,index) in projectList" :key="index">
            <div class="" style="width: 95%;background-color: #ffffff;padding: 25px 0;">
              <div class="flex_rowC" style="height: 85px">
                <img :src="item.icon" alt="">
              </div>
              <div style="color: #606266;margin-top: 10px">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel5">
      <div class="title textC">
        为什么选择萝卜猎手？
      </div>
      <div class="flex_rowC items">
        <div class="flex_rowL item" v-for="(item,index) in panel5List" :key="index">
          <img :src="item.icon" alt="">
          <div>
            <div style="color: rgba(254, 89, 3, 0.75);margin-bottom: 6px">{{item.title}}</div>
            <div class="color_909399">
              {{item.desc1}} <br>
              {{item.desc2}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel6">
      <div class="title textC">
        多类型套餐适配各种行业岗位
      </div>
      <div class="desc textC">
        5年服务经验  全面升级企业雇佣安全
      </div>
      <div class="relative">
        <div class="flex_rowC items">
          <div class="item flex_col_around textC color_ffffff"
               style="background-size: 100% 100%;z-index: 99"
               v-for="(item,index) in panel6List" :key="index"
               :style="{backgroundImage: 'url('+ item.bgImg +')'}">
            <div style="font-size: 1.5rem;margin-top: 15px">
              {{item.title}}
            </div>
            <div>
              <div class="" style="padding-bottom: 5px" v-for="(asset,idx) in item.desc" :key="idx">
                {{asset}}
              </div>
            </div>
          </div>
        </div>
        <div class="absolute" style="height: 180px;width: 100%;background-color: #ffffff;bottom: -40px;z-index: 0"></div>
      </div>
    </div>

    <div class="panel7">
      <div class="title textC">
        我们的背调流程
      </div>
      <div class="desc textC">
        国际化规范流程，快速交付每一份严谨客观的背调报告
      </div>
      <div class="flex_rowC">
        <div class="items flex_row_between">
          <div class="item relative flex_colC">
            <div class="num-icon flex_colB absolute">
              01
            </div>
            <div class="flex_rowC" style="margin-bottom: 20px;">
              <img src="@/assets/backdropInquiry_panel7_icon1.png" alt="">
            </div>
            <div class="textC">
              委托方发起背调
            </div>
          </div>
          <div class="flex_rowC" style="width: 95px;margin: 0 15px">
            <img src="@/assets/backdropInquiry_panel7_icon8.png" alt="">
          </div>
          <div class="item relative flex_colC">
            <div class="num-icon absolute">
              02
            </div>
            <div class="flex_rowC" style="margin-bottom: 20px;">
              <img src="@/assets/backdropInquiry_panel7_icon2.png" alt="">
            </div>
            <div class="textC">
              候选人授权
            </div>
          </div>
          <div class="flex_rowC" style="width: 95px;margin: 0 15px">
            <img src="@/assets/backdropInquiry_panel7_icon8.png" alt="">
          </div>
          <div class="item relative flex_colC">
            <div class="num-icon absolute">
              03
            </div>
            <div class="flex_rowC" style="margin-bottom: 20px;">
              <img src="@/assets/backdropInquiry_panel7_icon3.png" alt="">
            </div>
            <div class="textC">
              客观数据验证
            </div>
            <span class="color_FE8342">（极速秒出）</span>
          </div>
        </div>
      </div>
      <div class="flex_rowC">
        <div class="items flex_rowR">
          <div class="item_down">
            <div class="flex_rowC">
              <img src="@/assets/backdropInquiry_panel7_icon9.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="flex_rowC">
        <div class="items flex_rowC">
          <div class="item relative flex_colC">
            <div class="num-icon flex_colB absolute">
              06
            </div>
            <div class="flex_rowC" style="margin-bottom: 20px;">
              <img src="@/assets/backdropInquiry_panel7_icon4.png" alt="">
            </div>
            <div class="textC">
               背调报告交付
            </div>
          </div>
          <div class="flex_rowC" style="width: 95px;margin: 0 15px">
            <img src="@/assets/backdropInquiry_panel7_icon10.png" alt="">
          </div>
          <div class="item relative flex_colC">
            <div class="num-icon absolute">
              05
            </div>
            <div class="flex_rowC" style="margin-bottom: 20px;">
              <img src="@/assets/backdropInquiry_panel7_icon5.png" alt="">
            </div>
            <div class="textC">
               背调报告质检
            </div>
          </div>
          <div class="flex_rowC" style="width: 95px;margin: 0 15px">
            <img src="@/assets/backdropInquiry_panel7_icon10.png" alt="">
          </div>
          <div class="item relative flex_colC">
            <div class="num-icon absolute">
              04
            </div>
            <div class="flex_rowC" style="margin-bottom: 20px;">
              <img src="@/assets/backdropInquiry_panel7_icon6.png" alt="">
            </div>
            <div class="textC">
              工作经历核查
            </div>
            <span class="color_FE8342">（交叉复核验证）</span>
          </div>
        </div>
      </div>
    </div>

    <footer-Nav></footer-Nav>

    <el-dialog custom-class="dialogClass" width="317px" :visible.sync="dialogTableVisible1">
      <div class="dialog_penal PLR_4 PB_6 relative" style="width: 317px">
        <span class="el-icon-close absolute cursorPointer" style="top: 5%;right: 5%;color: #C0C4CC;font-size: 26px" @click="dialogTableVisible1=false"></span>

        <div class="flex_colC" style="padding-top: 50px">
          <div class="flex_rowC" style="width: 167px;height: 167px;border: 1px solid #E5E5E5;">
            <!-- <img :src="require('@/assets/tupian1.png')" style="width: 155px" alt=""> -->
            <img :src="require('@/assets/luobo_shunshun.5899a16.png')" style="width: 155px" alt="">
          </div>
        </div>
        <div class="textC" style="padding-bottom: 50px;padding-top: 20px;color: #4571D0;font-size: 18px">
          添加专属顾问  领取免费试用
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import '@/common/css/index.css'
  import headerTop from '@/components/headerTop';
  import footerNav from '@/components/footerNav';
  export default {
    data() {
      return {
        dialogTableVisible1:false,
        projectList:[
          {
            title:'身份信息核验',
            icon:require('@/assets/backdropInquiry_panel4_icon1.png')
          },
          {
            title:'教育背景核验',
            icon:require('@/assets/backdropInquiry_panel4_icon2.png')
          },
          {
            title:'职业技能资格核验',
            icon:require('@/assets/backdropInquiry_panel4_icon3.png')
          },
          {
            title:'健康证核验',
            icon:require('@/assets/backdropInquiry_panel4_icon4.png')
          },
          {
            title:'个人涉诉记录',
            icon:require('@/assets/backdropInquiry_panel4_icon5.png')
          },
          {
            title:'商业利益冲突查询',
            icon:require('@/assets/backdropInquiry_panel4_icon6.png')
          },
          {
            title:'金融监管处罚查询',
            icon:require('@/assets/backdropInquiry_panel4_icon7.png')
          },
          {
            title:'劳动仲裁记录核验',
            icon:require('@/assets/backdropInquiry_panel4_icon8.png')
          },
          {
            title:'限乘限飞查询',
            icon:require('@/assets/backdropInquiry_panel4_icon9.png')
          },
          {
            title:'限制高消费查询',
            icon:require('@/assets/backdropInquiry_panel4_icon10.png')
          },
          {
            title:'工作评价查看',
            icon:require('@/assets/backdropInquiry_panel4_icon11.png')
          },
          {
            title:'更多定制化服务',
            icon:require('@/assets/backdropInquiry_panel4_icon12.png')
          },
        ],
        panel5List:[
          {
            icon:require('@/assets/backdropInquiry_panel5_icon1.png'),
            title:'高效',
            desc1:'线上操作  秒出报告',
            desc2:'即刻了解TA'
          },
          {
            icon:require('@/assets/backdropInquiry_panel5_icon2.png'),
            title:'精准',
            desc1:'对接国家权威数据库',
            desc2:'让简历不再说谎'
          },
          {
            icon:require('@/assets/backdropInquiry_panel5_icon3.png'),
            title:'权威',
            desc1:'世界权威背景调查公司协会',
            desc2:'(NAPBS)正式成员'
          },
          {
            icon:require('@/assets/backdropInquiry_panel5_icon4.png'),
            title:'便捷',
            desc1:'随时随地',
            desc2:'一键尽在掌握'
          }
        ],
        panel6List:[
          {
            title:'通用岗位',
            desc:['产品技术类','客服运营类','市场营销类','销售类','通用岗位','…'],
            bgImg:require('@/assets/backdropInquiry_panel6_bg1.png')
          },
          {
            title:'热门行业',
            desc:['大健康医疗','娱乐传媒','物流运输','金融保险','服务业','…'],
            bgImg:require('@/assets/backdropInquiry_panel6_bg2.png')
          },
          {
            title:'生活场景',
            desc:['租个房子','找个家教','找个阿姨','找个教练','相亲交友','…'],
            bgImg:require('@/assets/backdropInquiry_panel6_bg3.png')
          },
        ]
      }
    },
    created() {

    },
    mounted() {
      this.toTop();
    },
    methods: {
      toTop() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const timeTop = setInterval(() => {
          // document.body.scrollTop = document.documentElement.scrollTop = 0;
          document.body.scrollTop = document.documentElement.scrollTop = scrollTop -= 20;
          if(scrollTop <= 0) {
            clearInterval(timeTop);
          }
        })
      },
      // 跳转登录
      toLogin(type) {
        let href;
        if(type == 1) {
          if(this.loginCode) {
            href = 'https://cop.luobobeidiao.cn/#/Login' + '/?loginCode=' + this.loginCode;
          } else {
            href = 'https://cop.luobobeidiao.cn/#/Login';
          }
        } else {
          href = 'https://bole.luobobeidiao.cn';
        }
      
        window.open(href, '_blank');
      },
      toRegister() {
        let href = 'https://cop.luobobeidiao.cn/#/Login';
        if(this.loginCode) {
          href = href + '/?loginCode=' + this.loginCode + '&type=register';
        } else {
          href = href + '/?type=register';
        }
        window.open(href, '_blank');
      },
    },
    computed: {},
    components: {
      headerTop,
      footerNav
    }
  }
</script>

<style scoped>
  .panel1 {
    padding: 50px 0;
  }
  .panel1 .panel1-item {
    width: 60%;
  }
  .panel1 .panel1-item .title {
    font-size: 2rem;
    color: rgba(69, 113, 208, 0.9);
  }
  .panel1 .panel1-item .desc {
    margin-top: 8px;
    font-size: 1.115rem;
    color: #606266;
  }


  .panel2 {
    height: 360px;
    color: #ffffff;
    background-image: url("../assets/backdropInquiry_top_bg2.png");
    background-size: 100% 100%;
  }
  .panel2 .title {
    font-size: 29px;
    line-height: 45px;
    padding-top: 30px;
  }
  .panel2 .desc {
    line-height: 30px;
    padding-bottom: 10px;
  }
  .panel3 {

  }
  .panel3 .title {
    padding: 30px 0;
    font-size: 28px;
    color: #303133;
    font-weight: 400;
  }
  .panel3 .video {
    padding-bottom: 30px;
    /*width: 1200px;*/

  }
  .panel3 .video video {
    height: 450px;
    object-fit: contain;
  }

  .panel4 {
    padding: 30px 0;
    background-color: #F8F8F8;
  }
  .panel4 .title {
    font-size: 2rem;
    color: #303133;
    margin-bottom: 10px;
  }
  .panel4 .desc {
    font-size: 20px;
    color: #606266;
  }
  .panel4 .items {
    width: 70%;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  .panel4 .items .item {
    /*background-color: #ffffff;*/
    margin-top: 10px;
    width: 25%;
  }
  .panel5 {
    padding: 40px 0;
  }
  .panel5 .title {
    font-size: 2rem;
    color: #303133;
    margin-bottom: 40px;
  }
  .panel5 .items .item {
    margin-right: 30px;
  }
  .panel5 .items .item img {
    margin-right: 15px;
  }
  .panel6 {
    padding: 40px 0;
    background-color: #F8F8F8;
  }
  .panel6 .title {
    font-size: 2rem;
    color: #303133;
    margin-bottom: 20px;
  }
  .panel6 .desc{
    color: #606266;
    font-size: 1.75rem;
    margin-bottom: 40px;
  }
  .panel6 .items .item {
    margin-right: 30px;
    background-size: 100% 100%;
    width: 230px;
    height: 250px;
    background: rgba(34, 34, 34, 0.5);
    box-shadow: 0px 2px 50px 0px rgba(0, 0, 0, 0.03);
    border-radius: 12px;
  }
  .panel7 {
    padding: 40px 0;
  }
  .panel7 .title {
    font-size: 2rem;
    color: #303133;
    margin-bottom: 20px;
  }
  .panel7 .desc{
    color: #606266;
    font-size: 1.75rem;
    margin-bottom: 40px;
  }
  .panel7 .items {
    width: 80%;
  }
  .panel7 .items .item{
    width: 20rem;
    height: 9.875rem;
    background: #FFFFFF;
    box-shadow: 0px 2px 60px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
  }

  .num-icon {
    right: 3%;
    bottom: 0;
    text-align: center;
    font-size: 18px;
    color: rgba(194, 194, 194, 0.75);
    line-height: 2.1rem;
    font-size: 3rem;
  }
  .item_down {
    width: 20rem;
    padding: 20px 0;
  }
  .color_909399 {
    color: #909399;
  }
  .color_606266 {
    color: #606266;
  }
  /deep/ .el-dialog {
    border-radius: 20px;
  }
  /deep/ .el-dialog__header {
    display: none;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    color: #000000;
  }
  .dialog_penal {

  }
  .dialog_penal .title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    padding: 20px 0;
  }
  .dialog_penal .desc {
    line-height: 25px;
    padding: 20px;
  }
  .color_FE8342 {
    color: #FE8342;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/view/backdropInquiry.vue